import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── TRENDY CARD ──────────────────────────────────────────────────────────────
// Matches the "brand strip" reference card: a colored header bar with the
// Matchwell wordmark, a full (uncropped) photo, and a two-column footer
// (name left, discount right). Distinct from every other carousel style.
export default function TrendyCard({ p, onNav, accent }) {
  const { dispatch, notify } = useStore();
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div onClick={()=>onNav("product", p.id)} style={{ borderRadius:14, overflow:"hidden", cursor:"pointer", border:"1px solid #f0f0f0", background:"white", boxShadow:"0 2px 12px rgba(0,0,0,0.05)" }}>
      <div style={{ background:accent, color:"white", fontWeight:700, fontSize:12.5, padding:"9px 14px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
        {p.name}
      </div>
      <div style={{ height:230, background:meta.light||"#fafafa", position:"relative", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"contain" }} loading="lazy"/>
          : <div style={{ fontSize:44, opacity:0.25 }}>{meta.emoji}</div>
        }
      </div>
      <div style={{ padding:"11px 13px 13px", display:"flex", justifyContent:"space-between", alignItems:"flex-end", gap:8 }}>
        <div style={{ minWidth:0 }}>
          <div style={{ fontSize:14.5, fontWeight:900, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</div>
          {p.mrp > p.price && <div style={{ fontSize:10.5, color:"#aaa", textDecoration:"line-through" }}>₹{p.mrp?.toLocaleString("en-IN")}</div>}
        </div>
        <div style={{ textAlign:"right", flexShrink:0 }}>
          {disc > 0 && <div style={{ color:accent, fontWeight:800, fontSize:11.5, lineHeight:1.3 }}>Up to<br/>{disc}% Off</div>}
          {p.stock > 0 && (
            <button onClick={addCart} style={{ marginTop:6, background:accent, color:"white", border:"none", padding:"5px 12px", borderRadius:16, fontSize:10, fontWeight:800, cursor:"pointer" }}>+ Add</button>
          )}
        </div>
      </div>
    </div>
  );
}
